import { Controller } from "@hotwired/stimulus"

// Select2 поверх обычного <select>. Навешивается инпутом Select2Input
// (app/inputs/select2_input.rb), вручную в разметке обычно не нужен.
//
// Если задан urlValue — варианты подгружаются с сервера постранично
// (JSON: { results: [{id, text, full_name, phone}], pagination: { more } }).
// Без него select2 ищет по вхождению внутри уже отрендеренных <option>.
export default class extends Controller {
  static values = {
    url: String,
    placeholder: String,
    allowClear: Boolean,
    minInput: { type: Number, default: 0 },
    pageSize: { type: Number, default: 20 },
    // Доп. query-параметры для ajax-поиска. Читаются в момент запроса,
    // поэтому владелец селекта может менять их на лету (см. pallet-picker).
    params: Object
  }

  connect() {
    if (typeof window.jQuery === "undefined") {
      console.error("Select2: jQuery не загружен")
      return
    }
    this.setupSelect2()
  }

  disconnect() {
    const $el = window.jQuery?.(this.element)
    if ($el?.data("select2")) $el.select2("destroy")
  }

  setupSelect2() {
    const $ = window.jQuery

    if (typeof $.fn.select2 === "undefined") {
      // Бандл ещё не догрузился — пробуем ещё раз.
      setTimeout(() => this.setupSelect2(), 100)
      return
    }

    const $el = $(this.element)
    if ($el.data("select2")) return

    $el.select2(this.config)

    // Select2 меняет значение в обход нативных событий — прокидываем change,
    // чтобы его увидели другие Stimulus-контроллеры на странице.
    $el.on("select2:select select2:unselect select2:clear", () => {
      this.element.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  get config() {
    const config = {
      theme: "bootstrap-5",
      width: "100%",
      placeholder: this.placeholderValue || "Выберите значение",
      allowClear: this.allowClearValue,
      minimumInputLength: this.minInputValue,
      language: {
        noResults: () => "Ничего не найдено",
        searching: () => "Поиск…",
        errorLoading: () => "Не удалось загрузить результаты",
        inputTooShort: ({ minimum, input }) =>
          `Введите ещё ${minimum - input.length} симв.`
      }
    }

    if (this.hasUrlValue) {
      config.ajax = this.ajaxConfig
      config.templateResult = this.renderResult
      config.templateSelection = this.renderSelection
    }

    return config
  }

  get ajaxConfig() {
    return {
      url: this.urlValue,
      dataType: "json",
      delay: 250,
      cache: true,
      data: (params) => ({ q: params.term || "", page: params.page || 1, ...this.paramsValue }),
      processResults: (data) => ({
        results: data.results || [],
        pagination: { more: Boolean(data.pagination?.more) }
      })
    }
  }

  // В выпадающем списке — две строки: заголовок и подпись (телефон).
  renderResult(item) {
    if (item.loading) return item.text

    const $ = window.jQuery
    const $row = $("<div>").text(item.text || "")
    if (item.phone) {
      $row.append($("<div class='small text-muted'>").text(item.phone))
    }
    return $row
  }

  // В самом поле — одна строка: «ФИО — телефон».
  renderSelection(item) {
    if (!item.id) return item.text
    return item.phone ? `${item.text} — ${item.phone}` : item.text
  }
}
